"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var HeaderBar = function (_a) {
    var title = _a.title, _b = _a.showBack, showBack = _b === void 0 ? true : _b, _c = _a.showMinimize, showMinimize = _c === void 0 ? true : _c, _d = _a.showClose, showClose = _d === void 0 ? true : _d, _e = _a.closeEnabled, closeEnabled = _e === void 0 ? false : _e, onBack = _a.onBack, onMinimize = _a.onMinimize, onRequestClose = _a.onRequestClose;
    return (react_1.default.createElement("div", { style: {
            display: "flex",
            alignItems: "center",
            gap: 8,
            padding: "10px 14px",
            borderBottom: "1px solid #F0F2F5",
        } },
        showBack && (react_1.default.createElement("button", { "aria-label": "Back", style: btn, onClick: function (e) {
                e.stopPropagation();
                onBack === null || onBack === void 0 ? void 0 : onBack();
            } },
            react_1.default.createElement("img", { src: "assets/Icon_BackArrow.svg", alt: "", width: 20, height: 20, style: img }))),
        react_1.default.createElement("div", { style: { fontWeight: 600, fontSize: 16, color: "#0b6060" } }, title),
        react_1.default.createElement("div", { style: { marginLeft: "auto" } }),
        showMinimize && (react_1.default.createElement("button", { "aria-label": "Minimize", style: btn, onClick: function (e) {
                e.stopPropagation();
                onMinimize === null || onMinimize === void 0 ? void 0 : onMinimize();
            } },
            react_1.default.createElement("img", { src: "assets/Icon_Minimized.svg", alt: "", width: 20, height: 20, style: img }))),
        showClose && (react_1.default.createElement("button", { "aria-label": "Close", style: __assign(__assign({}, btn), { cursor: closeEnabled ? "pointer" : "default" }), onClick: function (e) {
                e.stopPropagation();
                if (!closeEnabled)
                    return;
                onRequestClose === null || onRequestClose === void 0 ? void 0 : onRequestClose();
            } },
            react_1.default.createElement("img", { src: "assets/Icon_Close.svg", alt: "", width: 20, height: 20, style: img })))));
};
var btn = {
    background: "transparent",
    border: "none",
    cursor: "pointer",
    padding: 6,
    borderRadius: 8,
};
var img = {
    display: "block",
    pointerEvents: "none",
    userSelect: "none",
};
exports.default = HeaderBar;
